import { useState, useRef, useEffect } from 'react'
import { useLoadProgress } from './useLoadProgress'

/**
 * 暫存功能 hook
 * 三種身分來源任一成立就會載入暫存：userId（網址帶入）、sfdSamplerId、
 * webAuthType > 0（通行碼問卷，同一組通行碼後端會回同一組 ac/tk）。
 * 判斷條件在 useLoadProgress，存檔端的對應條件在 useSubmitAnswers 的 saveProgress。
 *
 * 使用方式（在 Agree.js 裡）：
 *
 *   // useConvertSurvey 之前：
 *   const userIdRef = useRef(null)
 *   useEffect(() => { if (userId) userIdRef.current = userId }, [userId])
 *
 *   // surveyModel 之後：
 *   useProgressSaving({ userIdRef, surveyModel, convertedSurvey: myAgreeJson, ... })
 */
export const useProgressSaving = ({
  userIdRef,
  surveyModel,
  convertedSurvey,
  requiresLogin,
  setIsLoading,
  pid,
  ac,
  tk,
  choiceIndexMapRef,
  choicesOrderRef,
  bringOptionsMapRef,
  sfdSamplerId,
  webAuthType = 0,
}) => {
  const [isReady, setIsReady] = useState(false)
  const otherAnswersRef = useRef({})
  const noneAnswersRef = useRef({})
  const matrixAnswersRef = useRef({})
  const timestampsRef = useRef({})

  useEffect(() => {
    if (surveyModel) {
      const id = setTimeout(() => setIsReady(true), 50)
      return () => clearTimeout(id)
    }
  }, [surveyModel])

  useLoadProgress({
    surveyModel,
    convertedSurvey,
    isReady,
    requiresLogin,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
    otherAnswers: otherAnswersRef.current,
    noneAnswers: noneAnswersRef.current,
    matrixAnswers: matrixAnswersRef.current,
    timestamps: timestampsRef.current,
    sfdSamplerId,
    webAuthType,
  })
}
